import { toast } from "react-toastify";
import swal from "sweetalert";

import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import bookclosurecss from "./../../css/bookclosure.module.css";
import Modal from "./../../elements/Modal";
import Card from "./../../elements/Card";

import React, { useState } from "react";
import { Button, TableButton } from "./../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import { ReactComponent as ClockIcon } from "../../assets/icons/clock.svg";
import { ReactComponent as GreendotIcon } from "../../assets/icons/greendot.svg";
import { ReactComponent as OrangedotIcon } from "../../assets/icons/orangedot.svg";
import { ReactComponent as ReddotIcon } from "../../assets/icons/reddot.svg";
import DefaultUser from "../../assets/imgs/default_user.png";
import companies from "../../data/companies.json";
import COAModal from "../../components/bookclosure/SelectCOAModal";
import {
  getAllCOA,
  pullERPdata,
} from "../../../Bookclosure/Services/ApiHandler";

const PullTBfromERPModal = ({
  handleClose,
  setAddTBModal,
  setPullTBfromERPModal,
  erpConnections,
  companyId,
  bookClosureId,
  handleAddTbModals,
  getBookClosureData,
  workspaceId,
}) => {
  const [coaModal, setCOAModal] = useState(false);

  const [selectedConnectionIndex, setSelectedConnectionIndex] = useState(null);
  const [selectedConnection, setSelectedConnection] = useState(null);
  const [erpTBId, setErpTBId] = useState(null);

  const truncateText = (text = "", maxLength = 10) =>
    text && text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  const handleCardClick = (connection, index) => {
    setSelectedConnectionIndex(index);
    setSelectedConnection(connection);
  };

  const addConnectionTB = () => {
    const payload = {
      bookClosureID: bookClosureId,
      companyID: companyId,
      requestID: selectedConnection._id,
    };
    // coaID: selectedCoa,
    pullERPdata(payload)
      .then((response) => {
        if (response.data.message === "Data Pulled") {
          setErpTBId(response.data.data._id);
          setCOAModal(true);
        } else {
          swal(
            "Error",
            response?.data?.message || "ERROR in adding ERP TB",
            "error"
          );
        }
        // getBookClosureData(companyId);
        // history workspaceId
        // window.location.href = `/bookclosure/${workspaceId}`;
        toast.success("ERP TB Added Successfully.");
        // handleAddTbModals("close");
        // setCOAModal(true);
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "ERROR in adding ERP TB",
          "error"
        );
        // handleAddTbModals("close");
      });
  };
  return (
    <>
      <Modal
        title="Add Trial Balance"
        bodycss={commoncss.unsetPadding}
        headerActions={
          <CloseIcon
            onClick={() => {
              handleClose();
              setAddTBModal(false);
              setPullTBfromERPModal(false);
              setCOAModal(false);
            }}
            className="clickable"
          />
        }
        width="50%"
        height="500px"
        onClose={() => console.log("Modal Closed")}
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                handleClose();
                setAddTBModal(false);
                setPullTBfromERPModal(false);
                setCOAModal(false);
              }}
              label="Cancel"
            />
            <Button
              btnColor={buttoncss.primary}
              label="Proceed"
              onClick={() => {
                // setCOAModal(true);
                addConnectionTB();
              }}
            />
          </>
        }
      >
        <div className={bookclosurecss.tbRequestsDiv}>
          {erpConnections.map((connection, index) => (
            <div
              className="m-2"
              onClick={() => handleCardClick(connection, index)}
            >
              <Card
                clickable={true}
                width="webkit-avaialable"
                height="fit-content"
                title={truncateText(connection.companyname, 14)}
                dimmed={selectedConnectionIndex === index ? "N" : "Y"}
              >
                <span className="card-info">
                  <CalenderIcon width={18} height={18} className="vaMiddle" />{" "}
                  &nbsp;{connection.transdatefrom} &nbsp;To&ensp;
                  <CalenderIcon
                    width={18}
                    height={18}
                    className="vaMiddle"
                  />{" "}
                  &nbsp;{connection.transdateto}
                </span>
                <br />
                <span className="card-info">
                  <ClockIcon width={18} height={18} /> &nbsp;
                  {connection.reqdatetime}
                </span>
                <br />

                <span className={`card-info ${commoncss.w100}`}>
                  {" "}
                  <img
                    className="card-user-img"
                    src={DefaultUser}
                    alt="user_image"
                  />{" "}
                  &nbsp;<span className="mt3">{connection.username}</span>
                </span>
                <br />
              </Card>
            </div>
          ))}
        </div>
      </Modal>
      {coaModal && erpTBId && (
        <COAModal
          setCOAModal={setCOAModal}
          companyId={companyId}
          selectedConnection={selectedConnection}
          bookClosureId={bookClosureId}
          handleAddTbModals={handleAddTbModals}
          getBookClosureData={getBookClosureData}
          workspaceId={workspaceId}
          erpTBId= {erpTBId}
        />
      )}
    </>
  );
};

export default PullTBfromERPModal;
